export default __webpack_public_path__ + "static/lorenzo-836feadb84897888a4c603ee0560c593.jpg";